import type { ReactNode } from 'react'

export function PageMessage({
  title,
  body,
  children,
}: {
  title: string
  body?: string
  children?: ReactNode
}) {
  return (
    <div className="page-message">
      <h1>{title}</h1>
      {body ? <p>{body}</p> : null}
      {children}
    </div>
  )
}
